module.exports = __webpack_public_path__ + "static/img/necklace.e034328.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/necklace.png
// module id = rFQT
// module chunks = 0